module.exports = __webpack_public_path__ + "assets/img/c1.926e9343.png";